import axios from "@/plugins/axios.js";

export default {
  //new functions
  async getClientInvoices(clientReference) {
    const invoices = await axios.postDataWithToken(
      "/auth/get-client-invoices",
      { clientReference },
      localStorage.getItem("token")
    );
    return invoices;
  },
  async createClient(
    name,
    clientReference,
    phone,
    institution,
    position,
    email,
    address,
    city,
    postalCode
  ) {
    const client = await axios.postDataWithToken(
      "/auth/save-client",
      {
        name: name,
        clientReference: clientReference,
        phone: phone,
        institution: institution,
        position: position,
        email: email,
        address: address,
        city: city,
        postalCode: postalCode,
      },
      localStorage.getItem("token")
    );
    return client;
  },
  async getAllClients() {
    const clients = await axios.getData(
      "/auth/get-all-clients",
      localStorage.getItem("token")
    );
    return clients;
  },
};
